export default __webpack_public_path__ + "266942afed1491fab7107b58c37d47f2.svg";